import { create } from 'zustand';

type ScopeInput = string | string[] | null | undefined;

const parseScopes = (input: ScopeInput): Set<string> => {
  const scopes = new Set<string>();
  if (!input) {
    return scopes;
  }
  if (Array.isArray(input)) {
    input.forEach((value) => {
      if (typeof value === 'string') {
        value
          .split(/\s+/)
          .map((entry) => entry.trim())
          .filter(Boolean)
          .forEach((entry) => scopes.add(entry));
      }
    });
    return scopes;
  }

  if (typeof input === 'string') {
    input
      .split(/\s+/)
      .map((entry) => entry.trim())
      .filter(Boolean)
      .forEach((entry) => scopes.add(entry));
    return scopes;
  }

  return scopes;
};

interface SessionState {
  scopes: Set<string>;
  setScopes: (input: ScopeInput) => void;
  hasScope: (scope: string) => boolean;
}

export const useSessionStore = create<SessionState>((set, get) => ({
  scopes: new Set<string>(),
  setScopes: (input: ScopeInput) => {
    set({ scopes: parseScopes(input) });
  },
  hasScope: (scope: string) => {
    if (!scope) return false;
    return get().scopes.has(scope);
  },
}));

export type SessionStore = typeof useSessionStore;
